module.exports = __webpack_public_path__ + "static/media/expertise-design.23b070aa.svg";